export const user = [
	{
		userId: 345,
		email: "rahul.rauniyar@otssolutions.com",
		name: "Rahul Rauniyar",
		password: "123456",
		mobile: 854600170,
	},
	{
		userId: 6461,
		email: "kiran.rauniyar@otssolutions.com",
		name: "Kiran rauniyar",
		password: "kiran@##12566",
		mobile: "Malum Nhi",
	},
	{
		userId: 846,
		email: "manisha@otssolutions.com",
		name: "manisha",
		password: "789456",
		mobile: 854600170,
	},
	{
		userId: 156,
		email: "arun@otssolutions.com",
		name: "arun",
		password: "123644",
		mobile: 854600170,
	},
];
